import type { BrandAppTabId } from '../lib/brandAppContract'

export type WebappPath = 'ExplorePage' | 'WelcomePage' | 'HomePage' | 'CompleteProfilePreview'

export type PreviewZone = 'explore' | 'home' | 'phone' | 'loyalty' | 'storeSelection' | 'profileInfo' | 'optin'

export const pathForZone = (zone: PreviewZone): WebappPath => {
  if (zone === 'explore') return 'ExplorePage'
  if (zone === 'storeSelection' || zone === 'profileInfo') return 'CompleteProfilePreview'
  if (zone === 'loyalty' || zone === 'optin') return 'HomePage'

  return 'WelcomePage'
}

export default function useWebappTabs(): {
  previewZone: Ref<PreviewZone>
  syncPreviewTab: (tab: BrandAppTabId) => void
} {
  const previewZone = ref<PreviewZone>('home')

  const syncPreviewTab = (tab: BrandAppTabId) => {
    previewZone.value = tab === 'loyalty' ? 'loyalty' : tab === 'home' ? 'explore' : 'home'
  }

  return {
    previewZone,
    syncPreviewTab
  }
}
